import SignOut from "../symbols/signOutAndClearAllReducers";

export function signOutAndClearReducers() {
  return (dispatch: any) => {
    dispatch(clearReduxAction());
  };
}
const clearReduxAction = () => ({
  type: SignOut.SIGN_OUT_AND_CLEAR_ALL_REDUCERS,
});
